import slider from './slider';
import swatches from './swatches';
import recommendations from './recommendations';
//import stickyATC from './stickyATC';

const scrollNav = () => {
  $('.anchors-items .anchors-item a').click(function(e){
    e.preventDefault();
    e.stopPropagation();
    $(".anchors-item .active").removeClass("active");     
    $(this).addClass("active");

/*    if($(this).attr('href') == '') {
      $('.anchors-item a[href=""]').addClass('active');
      $('.template-product').addClass('prod-specs');
      $(".product-main, #product-process, #product-faq, #product-reviews").hide();
      $("#product-tech").show();
      $("html, body").animate({ scrollTop: 0 }, "fast");       
     // $('.product-stickybar-top').removeClass('hide--mobile');
    }
    else {
      $('.template-product').removeClass('prod-specs');
      $(".product-main, #product-process, #product-faq, #product-reviews").show();
      $("#product-tech").hide();
      //$('.product-stickybar-top').addClass('hide--mobile');
      if($(this).attr('href') == '#shopify-section-ea-product-main') {
        setTimeout(function(){
          $("html, body").animate({ scrollTop: 0 }, 350);       
        }, 800);
      }
    }*/
  });

  let $div = $("#addToCartForm .product-add-to-cart"),
      $div2 = $(".afterpay-paragraph"),
      $div2text, div2oldtext;

  function fixDiv() {
    if ($("body.template-product-bundle").length > 0) return;

    $div = $("#addToCartForm .product-add-to-cart");
    $div2 = $(".afterpay-paragraph");
    $div2text = $(".afterpay-paragraph .afterpay-text1");
    div2oldtext = $(".afterpay-paragraph .afterpay-text1").text();

    if ($(window).scrollTop() > $div.data("top")) {
      $div.addClass('bottom-fixed');
      $div2.addClass('bottom-fixed');
      $div2text.text('Shop now. Pay later with');
      $('#shopify-section-ea-footer').addClass('bottom-fixed');
    }
    else {
      $div.removeClass('bottom-fixed');
      $div2.removeClass('bottom-fixed');
      $div2text.text(div2oldtext);
      $('#shopify-section-ea-footer').removeClass('bottom-fixed');
    }
  }

  if(typeof $div.offset() != "undefined"){
    $("#addToCartForm .product-add-to-cart").data("top", $("#addToCartForm .product-add-to-cart").offset().top); // set original position on load
  }

  $(window).scroll(fixDiv);
}

const scrollReviews = () => {
  if($('.template-product-bundle').length > 0 ) {
    $(document).on('click', '[data-link]', function () {
      const thisLink = $(this).attr('data-link');
      const $elem = $(`[${thisLink}]`);

      if ($elem) $elem[0].scrollIntoView({behavior: "auto", block: "end", inline: "nearest"});
    });

  }
}

export default function() {
  scrollReviews();
  slider();
  swatches();
  recommendations();  
  scrollNav();  
  //stickyATC();
}